import {useEffect} from "react"
import Loading from "../../components/loading"
import {useNavigate} from "react-router-dom"

export default function ClearCache({account}) {
  const navigate = useNavigate()

  useEffect(() => {
    const keysToMatch = ["planejamentos", "pilulas", "companySizes", "currentFampe"]

    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (!key) continue

      const shouldRemove = keysToMatch.some((sub) => key.includes(sub))

      if (shouldRemove) {
        localStorage.removeItem(key)
      }
    }

    console.log({ status: "Ok!", message: "Cache cleared successfully." })

    const t = setTimeout(() => navigate(!account ? '/' : '/planejadora'), 300)
    return () => clearTimeout(t)

    // eslint-disable-next-line
  }, [navigate])

  return (
    <div style={{ padding: "20px" }}>
      <Loading fullPage />
    </div>
  )
}
